// Card themes for profile pages
export const CARD_THEMES = {
  forest: {
    name: 'Хвойный лес', group: 'dark',
    bg: '#141e12', card: '#1e2a1b', cardDeep: '#16201414', border: '#334030',
    text: '#e8e4dc', textSec: '#a0998c', textMuted: '#6b7866', textFaint: '#4a5845',
    accent: '#c4623a', accentMuted: 'rgba(196,98,58,0.15)',
  },
  sand: {
    name: 'Тёплый песок', group: 'light',
    bg: '#f5f0e8', card: '#ffffff', cardDeep: '#f0ebe3', border: '#ddd5c8',
    text: '#2a2520', textSec: '#6b6560', textMuted: '#a09890', textFaint: '#c8c0b5',
    accent: '#c4623a', accentMuted: 'rgba(196,98,58,0.1)',
  },
  lavender: {
    name: 'Лавандовый туман', group: 'light',
    bg: '#f0ecf5', card: '#ffffff', cardDeep: '#ebe6f2', border: '#d5cee0',
    text: '#2a2535', textSec: '#655e70', textMuted: '#9890a5', textFaint: '#c0b8cc',
    accent: '#7c5cb0', accentMuted: 'rgba(124,92,176,0.12)',
  },
  ocean: {
    name: 'Океанский бриз', group: 'light',
    bg: '#eaf2f5', card: '#ffffff', cardDeep: '#e2ecf0', border: '#c8d8e0',
    text: '#1a2830', textSec: '#506068', textMuted: '#8898a0', textFaint: '#b0c0c8',
    accent: '#2a7a8a', accentMuted: 'rgba(42,122,138,0.12)',
  },
  rose: {
    name: 'Пудровая роза', group: 'light',
    bg: '#f5eeef', card: '#ffffff', cardDeep: '#f0e8ea', border: '#e0d0d5',
    text: '#302025', textSec: '#705860', textMuted: '#a09098', textFaint: '#c8b8c0',
    accent: '#b55a6a', accentMuted: 'rgba(181,90,106,0.12)',
  },
  indigo: {
    name: 'Тёмный индиго', group: 'dark',
    bg: '#12141e', card: '#1a1d2a', cardDeep: '#141620', border: '#2a3045',
    text: '#dce0e8', textSec: '#8c90a0', textMuted: '#5a6078', textFaint: '#3a4058',
    accent: '#6a7adf', accentMuted: 'rgba(106,122,223,0.15)',
  },
  mint: {
    name: 'Мятная свежесть', group: 'light',
    bg: '#ecf5f2', card: '#ffffff', cardDeep: '#e4f0ec', border: '#c8e0d8',
    text: '#1a2825', textSec: '#506860', textMuted: '#88a098', textFaint: '#b0c8c0',
    accent: '#3a8a6a', accentMuted: 'rgba(58,138,106,0.12)',
  },
  graphite: {
    name: 'Тёплый графит', group: 'dark',
    bg: '#1a1918', card: '#242220', cardDeep: '#1e1c1a', border: '#3a3835',
    text: '#e8e4dc', textSec: '#a09890', textMuted: '#706860', textFaint: '#504840',
    accent: '#d4956a', accentMuted: 'rgba(212,149,106,0.15)',
  },
};

export const THEME_LIST = Object.entries(CARD_THEMES).map(([id, t]) => ({ id, ...t }));

export function themeToCSS(theme) {
  const t = typeof theme === 'string' ? CARD_THEMES[theme] : theme;
  if (!t) return {};
  return {
    '--p-bg': t.bg, '--p-card': t.card, '--p-card-deep': t.cardDeep, '--p-border': t.border,
    '--p-text': t.text, '--p-text-sec': t.textSec, '--p-text-muted': t.textMuted, '--p-text-faint': t.textFaint,
    '--p-accent': t.accent, '--p-accent-muted': t.accentMuted,
  };
}
